module.exports = "<a ng-click=\"showMap()\" href=\"#\" class=\"mapHoverable\">{{pickupOption.name}}</a>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/directives/pickupOptionMap/pickupOptionMap.html
// module id = 261
// module chunks = 0